import { RootState } from "@/store/store";
import { ModuleTree } from "vuex";
import { duplicateCitationState } from "./duplicate-citation.state";
import { DuplicateCitationActions as duplicateCitationActions } from "./duplicate-citation.actions";
import { duplicateCitationMutations } from "./duplicate-citation.mutations";

export default {
    namespaced: true,
    state: duplicateCitationState,
    actions: duplicateCitationActions,
    mutations: duplicateCitationMutations,
} as unknown as ModuleTree<RootState>;